module.exports = __webpack_public_path__ + "img/ic_sinistre.1e998ed2.svg";